import { extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import { messages } from 'vee-validate/dist/locale/en.json';

function getForms(form){
   try {
      if(!global_forms[form]){
         throw 'Form not found'
      }else{
         return global_forms[form]
      }
   } catch (err) {throw err}
}

function getNestedObject(nestedObj, path) {
   let pathArr = path.split('.')

   return pathArr.reduce((obj, key) =>
      (obj && obj[key] !== 'undefined') ? obj[key] : undefined, nestedObj);
}

export function initialize(){
   try {
      Object.keys(rules).forEach(rule => {
         console.log()

         if(rule !== 'required_if'){
            extend(rule, {
               ...rules[rule], // copies rule configuration
               message: messages[rule] // assign message
            });
         }
      });

      extend('phone', {
         message: (field,args) => {
            return `${field} field has an invalid phone number`
         },
         validate: (value,args) => {
            let mobile = ''
            
            if(value.mobile === undefined){
               mobile = value
            }else{
               mobile = `+${value.code.calling_code}${value.mobile}`
            }
            
            return mobile.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im)
         }
      });

      extend('required_with', {
         message: (field,args) => {
            let _args = []

            for (const [key,val] of Object.entries(args)) {
               if(Number(key) && Number(key) > 0){
                  _args.push(val)
               }
            }

            _args = _args.join(' and ')
            return `${field} field is required with ${_args} field(s)`
         },
         validate: (value,args) => {
            let form = getForms(args[0])
            console.log(args,form)
            for (let i = 1; i < args.length; i++) {
               const data = getNestedObject(form,args[i]);
               
               if(data === undefined || data === null){
                  throw 'Model not found'
               }
               
               if(!rules['required'].validate(data).valid){
                  return false
               }
            }

            return true
         }
      });

      extend('required_without', {
         message: (field,args) => {
            let _args = []

            for (const [key,val] of Object.entries(args)) {
               if(Number(key) && Number(key) > 0){
                  _args.push(val)
               }
            }

            _args = _args.join(' and ')
            return `${field} field is required without ${_args} field(s)`
         },
         validate: (value,args) => {
            let form = getForms(args[0])
            for (let i = 1; i < args.length; i++) {
               const data = getNestedObject(form,args[i]);
               
               if(data === undefined || data === null){
                  throw 'Model not found'
               }
               
               if(rules['required'].validate(data).valid){
                  return false
               }
            }

            if(!rules['required'].validate(value).valid){
               return false
            }
            return true
         }
      });

      extend('confirm', {
         message: (field,args) => {
            return `${field} field must be equal to ${args[1]} field`
         },
         validate: (value,args) => {
            let form = getForms(args[0])
            const data = getNestedObject(form,args[1]);

            if(data !== value){
               return false
            }
            return true
         }
      });
   } catch (err) {
      throw err
   }
}